import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import Spinner from "react-bootstrap/Spinner";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import ProductMenu from "../ProductMenu";
import { selectCatalogItem, getAdminCatalogItem, selectOtherCatalogItems, addColor, selectDecorations, selectInventory, selectStyle } from '../../reducers/catalog';
import { addToCart, cartCount } from '../../reducers/cart';
import { isLoggedIn, isSuperAdmin, getSubsite } from '../../reducers/auth';
import { getMenu } from '../../reducers/menu';
import { useLocation, useNavigate } from "react-router-dom";
import Modal from 'react-bootstrap/Modal';
import ImageEditModal from '../modals/ImageEditModal';
import CatalogService from '../../services/catalog.service';
import CategoryService from '../../services/category.service';
import LogoService from '../../services/logo.service';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { ArrowClockwise, ArrowCounterclockwise, DashLg, PlusLg, Shuffle, Check, Pencil, PlusCircle, XCircle, Asterisk } from 'react-bootstrap-icons';
import AddLogoModal from '../modals/AddLogoModal';
import AdminService from '../../services/admin.service';
import AddRemoveCategoryModal from "../modals/AddRemoveCatagoryModal";
import CloneProductModal from "../modals/CloneProductModal";
import CategoryList from "../CategoryList";
import LogoButton from "../LogoButton";

const ProductDetails = () => {
  const apiUrl = process.env.REACT_APP_LOCALHOST_URL;
  let navigate = useNavigate();
  const dispatch = useDispatch();
  let catalogItem = useSelector(selectCatalogItem);
  const decorations = useSelector(selectDecorations);
  const inventory = useSelector(selectInventory);
  let otherProductItems = useSelector(selectOtherCatalogItems);
  const itemStatus = useSelector(state => state.catalog.adminItemStatus)
  const [imgSrc, setImgSrc] = useState(null);
  const [imgSrcBack, setImgSrcBack] = useState(null);
  const [currentItem, setCurrentItem] = useState(null);
  const [currentDecorations, setCurrentDecorations] = useState(null);
  const currentStyle = useSelector(selectStyle);
  const [currentColor, setCurrentColor] = useState(null);
  const [currentSize, setCurrentSize] = useState(null);
  const [currentPrice, setCurrentPrice] = useState(null);
  const [currentDragColor, setCurrentDragColor] = useState(null);
  const [currentDragColorSizes, setCurrentDragColorSizes] = useState(new Array());
  const [currentImages, setCurrentImages] = useState(null);
  const [currentImage, setCurrentImage] = useState(null);

  const location = useLocation();
  const loginStatus = useSelector(isLoggedIn);
  const [show, setShow] = useState(false);
  const [addSizes, setAddSizes] = useState("");
  const [imageModalShow, setImageModalShow] = useState(false);
  const [selectedDecoration, setSelectedDecoration] = useState([]);
  const [availableColors, setAvailableColors] = useState(null);
  const [selectedColors, setSelectedColors] = useState([]);
  const [logoSrc, setLogoSrc] = useState("");
  const [editedHtmlDescription, setEditedHtmlDescription] = useState('');
  const handleSizeModalClose = () => setShow(false);
  const [showDescription, setShowDescription] = useState(false);
  const handleDescriptionModalClose = () => setShowDescription(false);
  const [descriptionChanged, setDescriptionChanged] = useState(false);
  const currentSubsite = useSelector(getSubsite);
  //  const handleShow = () => setShow(true);

  const [selectedLogos, setSelectedLogos] = useState([]);
  const [logosByPosition, setLogosByPosition] = useState([]);
  const [currentLogoPrice, setCurrentLogoPrice] = useState([]);

  const [currentLogoPosition, setCurrentLogoPosition] = useState(null);
  const [updateMode, setUpdateMode] = useState("color");
  const [addLogoModalShow, setAddLogoModalShow] = useState(false);
  const [categoryModalShow, setCategoryModalShow] = useState(false);
  const [cloneProductModalShow, setCloneProductModalShow] = useState(false);

  const [addFeaturedMessage, setAddFeaturedMessage] = useState("");
  const [logoPosiitonSpinner, setLogoPosiitonSpinner] = useState(false);
  const [priceUpdateSpinner, setPriceUpdateSpinner] = useState(false);

  let qty = 1;
  let productId = location.state.productId;
  //  let selectedColor = location.state.colorId;


  /*  const qtyChanged = (event) => {
      qty = parseInt(event.target.value);
    }
  ', "cost":', p2.costSingle),
  ', "price2X":', adjust_price_subsite(p2.costSingle2X),
  ', "costSingle2X":', adjust_price_subsite(p2.costSingle2X),
  */

  useEffect(() => {
    console.log("UPDATE CURRENT PRICE", currentLogoPrice, currentItem?.sizes[0].costSingle2X + currentLogoPrice);
    setCurrentPrice((currentItem?.sizes[0].costSingle2X + currentLogoPrice).toLocaleString(undefined, { maximumFractionDigits: 2 }));
  }, [currentLogoPrice]);

  const colorImageClick = async (item) => {
    console.log("ITEM CLIKCED", item);
    if(item.frontModelImage.includes("uploads")) {
      setImgSrc("http://localhost:5000/" + item.frontModelImage);
    } else {
      setImgSrc(item.frontModelImage);
    }
    setImgSrcBack(item.backModelImage);
    setCurrentItem(item);
    setCurrentColor(item.colorName);
    setCurrentSize(0);
    await loadImages(item.sizes[0].productId);

    var decoCost = 0;
    for (var i = 0; i < selectedLogos.length; i++) {
      console.log("DECORATION", selectedLogos[i]);
      decoCost += selectedLogos[i].price;
    }
    //setCurrentPrice((item.sizes[0].costSingle2X + currentLogoPrice).toLocaleString(undefined, { maximumFractionDigits: 2 }));
    //updateLogosByPostion(item.logos);
  }

  const closeImageModal = () => {
    setImageModalShow(false);
  }
  const removeProduct = async (event) => {
    console.log("REMOVE PRODUCT", productId);
    await CatalogService.removeFromCatalog(productId);
    navigate("/admin/catalog/0");
  }

  const colorImageOver = (item) => {
    if(item.frontModelImage.contains("uploads")) {
      setImgSrc("http://localhost:5000/" + item.frontModelImage);
    } else {
      setImgSrc(item.frontModelImage);
    }
    setCurrentColor(item.colorName);
    if (item.logos) {
      setLogoSrc(JSON.parse(item.logos)[0][0]);
    }
  }

  const colorImageExit = (item) => {

    if(currentItem.frontModelImage.contains("uploads")) {
      setImgSrc("http://localhost:5000/" + currentItem.frontModelImage);
    } else {
      setImgSrc(currentItem.frontModelImage);
    }


    setImgSrc(currentItem.frontModelImage);
    setCurrentColor(currentItem.colorName);
    if (currentItem.logos) setLogoSrc(JSON.parse(currentItem.logos)[0][0]);
  }

  const sizeClick = (event) => {
    setCurrentSize(event.target.getAttribute("data"));
    setCurrentPrice(currentItem.sizes[event.target.getAttribute("data")].costSingle2X.toLocaleString(undefined, { maximumFractionDigits: 2 }));

  }

  const addToCartButtonClicked = () => {
    if (!loginStatus) return;

    if (!currentSize) {
      alert("Please select a size");
      return;
    }
    console.log("PROD ID", currentItem);
    let currentProduct = currentItem.sizes[currentSize].productId;
    dispatch(addToCart({ item: currentItem, quantity: qty, sizeIdx: currentSize }));
    console.log("PROD ID", currentProduct);
  }

  useEffect(() => {
    const fetchData = async () => {
      let images = await CatalogService.getImagesForProduct(productId);
      setCurrentImages(images.images);
    }
    dispatch(getAdminCatalogItem(productId));
    fetchData();
  }, [location.key]);

  useEffect(() => {
    console.log("IN DESCRIPTIONCHANGED", productId);
    dispatch(getAdminCatalogItem(productId));
  }, [descriptionChanged]);

  useEffect(() => {
    console.log("IN EFFECT", itemStatus);
    if (itemStatus === 'idle') {
      dispatch(getAdminCatalogItem(productId));
      setCurrentPrice("Loading");
    }
    if (itemStatus === 'succeeded') {
      colorImageClick(catalogItem[0]);

      // generate color arrays
      var newAvailableColors = [];
      var newSelectedColors = [];
      for (var i = 0; i < catalogItem.length; i++) {
        newSelectedColors.push(JSON.parse(JSON.stringify(catalogItem[i])));
      }
      setSelectedColors(newSelectedColors);

      for (var i = 0; i < otherProductItems.length; i++) {
        newAvailableColors.push(JSON.parse(JSON.stringify(otherProductItems[i])));
      }
      setAvailableColors(newAvailableColors);
      //AdminService.loadInventory(catalogItem[0].productId);
      //loadImages(catalogItem[0].productId);



      setCurrentItem(catalogItem[0]);
      console.log("Decorations", decorations);
      console.log("CatalogItem", catalogItem[0]);
      setCurrentDecorations(decorations);
      setCurrentPrice(catalogItem[0].sizes[0].costSingle2X.toLocaleString(undefined, { maximumFractionDigits: 2 }));
      setCurrentSize(0);
      //if(decorations)
      //updateLogosByPostion(decorations);
      loadImages(catalogItem[0].productId);

      if (catalogItem[0].htmlDescription) {
        setEditedHtmlDescription(catalogItem[0].htmlDescription);
      } else {
        setEditedHtmlDescription(catalogItem[0].description);
      }
    }
  }, [itemStatus, dispatch]);

  const updateLogosByPostion = async (logos) => {
    console.log("UPDATE LOGOS BY POSITION", logos);
    if (!logos || logos.length === 0) {
      setSelectedLogos([]);
      setLogosByPosition([]);
      setCurrentLogoPrice(0);
      return;
    }

    var newLogosByPosition = [];
    var currentPos = -1;
    var currentPosLogos = [];
    var newSelectedLogos = [];
    var currIdx = -1;
    var first = false;
    var firstInGroupIdx = 0;
    var selectedDeco = null;
    for (var i = 0; i < logos.length; i++) {
      if (logos[i].locId !== currentPos) {
        currIdx++;
        newLogosByPosition[currIdx] = [];
        first = true;
        if (!selectedDeco && currentPos != -1) {
          // select the first in this group
          newSelectedLogos.push(logos[firstInGroupIdx]);
        }
        currentPos = logos[i].locId;
        selectedDeco = null;
        firstInGroupIdx = i;
      }
      newLogosByPosition[currIdx].push(logos[i]);

      if (selectedDecoration && !selectedDeco) {
        if (selectedDecoration.subsiteDecorationId === logos[i].subsiteDecorationId) {
          newSelectedLogos.push(logos[i]);
          selectedDeco = logos[i];
        }
      }
    }
    if (!selectedDeco) {
      newSelectedLogos.push(logos[firstInGroupIdx]);
    }


    setSelectedLogos(newSelectedLogos);
    setLogosByPosition(newLogosByPosition);

    var logoPrice = 0;
    for (var i = 0; i < newSelectedLogos.length; i++) {
      logoPrice += newSelectedLogos[i].price;
    }
    setCurrentLogoPrice(logoPrice);
    setCurrentPrice((currentItem.sizes[0].costSingle2X + logoPrice).toLocaleString(undefined, { maximumFractionDigits: 2 }));
  }

  const drop = (color) => {
    console.log("COLOR DROPPED");
    console.log(color.colorId);
    console.log(currentDragColor);

  };

  const handleSizeCheck = (event) => {
    const target = event.target
    const checked = target.checked
    const label = target.id;
    var sizes = currentDragColorSizes;
    if (checked) sizes.push(label);
    else {
      for (var i = 0; i < sizes.length; i++) {
        if (sizes[i] === label) {
          break;
        }
      }
      sizes.splice(i, 1);
    }
    setCurrentDragColorSizes(sizes);
  };
  const addColorDropOld = async (e) => {
    console.log("COLOR DROPPED IN COLOR DIV", currentDragColor);

    const color = await CatalogService.addColorToCatalogItem(currentDragColor.colorId, catalogItem[0].id);

    // remove from available colors
    var removedItems = null;
    var newOtherProductItems = JSON.parse(JSON.stringify(otherProductItems));

    for (var i = 0; i < newOtherProductItems.length; i++) {
      console.log("OTHER PRODUCT ITEM", newOtherProductItems[i], currentDragColor);
      if (newOtherProductItems[i].colorName === currentDragColor.colorName) {
        removedItems = newOtherProductItems.splice(i, 1);
        break;
      }
    }
    otherProductItems = newOtherProductItems;

    var newCatalogItem = JSON.parse(JSON.stringify(catalogItem));
    newCatalogItem.push(removedItems[0]);
    catalogItem = newCatalogItem;

    var newSelectedColors = JSON.parse(JSON.stringify(selectedColors));
    newSelectedColors.push(removedItems[0]);
    setSelectedColors(newSelectedColors);

    var newAvailableColors = JSON.parse(JSON.stringify(availableColors));
    for (var i = 0; i < newAvailableColors.length; i++) {
      if (newAvailableColors[i].colorName === currentDragColor.colorName) {
        newAvailableColors.splice(i, 1);
        break;
      }
    }
    setAvailableColors(newAvailableColors);

    // add to product colors



    /*    setCurrentDragColorSizes(new Array());
        console.log(currentDragColor);
    
        for( var i=0; i<otherProductItems.length; i++) {
          if(currentDragColor === otherProductItems[i].colorName) {
            console.log("OTHER SIZES", otherProductItems[i].sizes);
            if(otherProductItems[i].sizes.length >= 1) {
              // choose sizes
              var chooseSizes = new Array();;
              for(var j=0; j< otherProductItems[i].sizes.length; j++) {
                chooseSizes.push( <Form.Check
                type="checkbox"
                label={`${otherProductItems[i].sizes[j].sizeName}`}
                id={`${otherProductItems[i].sizes[j].productId}`}
                onChange={handleSizeCheck}/>);
              }
              setAddSizes(chooseSizes);
              //setShow(true);
              dispatch(addColor());
            }
          }
        }
        */
  };
  const addColorDrop = async (e) => {
    console.log("COLOR DROPPED IN COLOR DIV", currentDragColor);

    const color = await CatalogService.addColorToCatalogItem(currentDragColor.colorId, catalogItem[0].id);

    // remove from available colors
    var removedItems = [];
    var newAvailableColors = JSON.parse(JSON.stringify(availableColors));

    for (var i = 0; i < newAvailableColors.length; i++) {
      console.log("OTHER PRODUCT ITEM", newAvailableColors[i], currentDragColor);
      if (newAvailableColors[i].colorName === currentDragColor.colorName) {
        removedItems = newAvailableColors.splice(i, 1);
        break;
      }
    }
    setAvailableColors(newAvailableColors);

    var newCatalogItem = JSON.parse(JSON.stringify(catalogItem));
    newCatalogItem.push(removedItems[0]);
    catalogItem = newCatalogItem;

    var newSelectedColors = JSON.parse(JSON.stringify(selectedColors));
    newSelectedColors.push(removedItems[0]);
    setSelectedColors(newSelectedColors);

    var newAvailableColors = JSON.parse(JSON.stringify(availableColors));
    for (var i = 0; i < newAvailableColors.length; i++) {
      if (newAvailableColors[i].colorName === currentDragColor.colorName) {
        newAvailableColors.splice(i, 1);
        break;
      }
    }
    setAvailableColors(newAvailableColors);

    // add to product colors



    /*    setCurrentDragColorSizes(new Array());
        console.log(currentDragColor);
    
        for( var i=0; i<otherProductItems.length; i++) {
          if(currentDragColor === otherProductItems[i].colorName) {
            console.log("OTHER SIZES", otherProductItems[i].sizes);
            if(otherProductItems[i].sizes.length >= 1) {
              // choose sizes
              var chooseSizes = new Array();;
              for(var j=0; j< otherProductItems[i].sizes.length; j++) {
                chooseSizes.push( <Form.Check
                type="checkbox"
                label={`${otherProductItems[i].sizes[j].sizeName}`}
                id={`${otherProductItems[i].sizes[j].productId}`}
                onChange={handleSizeCheck}/>);
              }
              setAddSizes(chooseSizes);
              //setShow(true);
              dispatch(addColor());
            }
          }
        }
        */
  };

  const handleAddSizesClick = () => {
    dispatch(addColor(currentDragColorSizes));
  };

  const removeColorDrop = async (e) => {
    console.log("COLOR DROPPED IN REMOVE COLOR DIV");
    console.log(currentDragColor);

    const color = await CatalogService.removeColorFromCatalogItem(currentDragColor.colorId, catalogItem[0].id);

    var newCatalogItem = JSON.parse(JSON.stringify(catalogItem));
    // remove item from catalogItem
    for (var i = 0; i < newCatalogItem.length; i++) {
      if (newCatalogItem[i].colorName === currentDragColor.colorName) {
        newCatalogItem.splice(i, 1);
        break;
      }
    }

    catalogItem = newCatalogItem;
    var removedItems = null;

    var newSelectedColors = JSON.parse(JSON.stringify(selectedColors));
    // remove item from selectedColors
    for (var i = 0; i < newSelectedColors.length; i++) {
      if (newSelectedColors[i].colorName === currentDragColor.colorName) {
        removedItems = newSelectedColors.splice(i, 1);
        break;
      }
    }
    setSelectedColors(newSelectedColors);

    var newAvailableColors = JSON.parse(JSON.stringify(availableColors));
    newAvailableColors.push(removedItems[0]);
    setAvailableColors(newAvailableColors);

  };

  const allowDrop = (e) => {
    e.preventDefault();
  };

  const toggleLightColor = async (e, item) => {
    console.log("TOGGLE LIGHT", item);
    if (!item.light || item.light === false) {
      var newLogos = await CatalogService.toggleLight(item.colorId, true, item.productId);
      e.target.style.backgroundColor = "#FFFFFF";
      e.target.style.borderColor = "#000000";
      var newCatalogItem = JSON.parse(JSON.stringify(catalogItem));
      for (var i = 0; i < newCatalogItem.length; i++) {
        if (newCatalogItem[i].id === item.id) {
          newCatalogItem[i].light = true;
          break;
        }
      }
      //setCatalogItem(newCatalogItem);
    } else {
      var newLogos = await CatalogService.toggleLight(item.colorId, false, item.productId);
      e.target.style.backgroundColor = "#000000";
      e.target.style.borderColor = "#FFFFFF";
      var newCatalogItem = JSON.parse(JSON.stringify(catalogItem));
      for (var i = 0; i < newCatalogItem.length; i++) {
        if (newCatalogItem[i].id === item.id) {
          newCatalogItem[i].light = false;
          break;
        }
      }
      //setCatalogItem(newCatalogItem);
    }
    await loadImages(item.productId);

  }

  const toggleLightLogo = async (item) => {
    console.log("TOGGLE LIGHT", item);
    var newLogos = await LogoService.toggleLight(item.subsiteDecorationId, currentItem.productId);

    /*if(!item.light || item.light === false) {
      var newLogos = await CatalogService.toggleLight(item.colorId, true, item.productId);
      e.target.style.backgroundColor = "#FFFFFF";
      e.target.style.borderColor = "#000000";
      var newCatalogItem = JSON.parse(JSON.stringify(catalogItem));
      for(var i=0; i<newCatalogItem.length; i++) {
        if(newCatalogItem[i].id === item.id) {
          newCatalogItem[i].light = true;
          break;
        }
      }
      //setCatalogItem(newCatalogItem);
    } else {
      var newLogos = await CatalogService.toggleLight(item.colorId, false, item.productId);
      e.target.style.backgroundColor = "#000000";
      e.target.style.borderColor = "#FFFFFF";
      var newCatalogItem = JSON.parse(JSON.stringify(catalogItem));
      for(var i=0; i<newCatalogItem.length; i++) {
        if(newCatalogItem[i].id === item.id) {
          newCatalogItem[i].light = false;
          break;
        }
      }
      //setCatalogItem(newCatalogItem);
    }
      */
    await loadImages(currentItem.productId);

  }
  const decoClicked = (logo) => {
    var newSelectedLogos = [];
    for (var i = 0; i < selectedLogos.length; i++) {
      if (selectedLogos[i].locId === logo.locId) {
        newSelectedLogos[i] = logo;
      } else {
        newSelectedLogos[i] = selectedLogos[i];
      }
    }

    setSelectedLogos(newSelectedLogos);
    setSelectedDecoration(logo);
  }


  const dragStarted = (color) => {
    console.log("DRAG STARTED", color);
    setCurrentDragColor(color);
  }

  const increaseLogoSize = () => {
    var newSelectedDecoration = JSON.parse(JSON.stringify(selectedDecoration));
    newSelectedDecoration.width += 1;
    newSelectedDecoration.height += 1;
    setSelectedDecoration(newSelectedDecoration);

    updateSelectedLogos(newSelectedDecoration);
  }
  const decreaseLogoSize = () => {
    var newSelectedDecoration = JSON.parse(JSON.stringify(selectedDecoration));
    newSelectedDecoration.width -= 1;
    newSelectedDecoration.height -= 1;
    setSelectedDecoration(newSelectedDecoration);

    updateSelectedLogos(newSelectedDecoration);
  }
  const rotateClockwise = () => {
    var newSelectedDecoration = JSON.parse(JSON.stringify(selectedDecoration));
    newSelectedDecoration.rotate += 2;
    setSelectedDecoration(newSelectedDecoration);

    updateSelectedLogos(newSelectedDecoration);
  }
  const rotateCClockwise = () => {
    var newSelectedDecoration = JSON.parse(JSON.stringify(selectedDecoration));
    newSelectedDecoration.rotate -= 2;
    setSelectedDecoration(newSelectedDecoration);

    updateSelectedLogos(newSelectedDecoration);

  }


  const imageClicked = (e) => {
    // e = Mouse click event.
    var rect = e.target.getBoundingClientRect();
    var x = e.clientX - rect.left; //x position within the element.
    var y = e.clientY - rect.top;  //y position within the element.
    console.log("Left? : " + x + " ; Top? : " + y + "." + "Width" + rect.width + "Height" + rect.height);

    var newX = (x / rect.width) * 100;
    var newY = (y / rect.height) * 100;

    var newSelectedDecoration = JSON.parse(JSON.stringify(selectedDecoration));
    newSelectedDecoration.x = newX;
    newSelectedDecoration.y = newY;
    setSelectedDecoration(newSelectedDecoration);
    updateSelectedLogos(newSelectedDecoration);

  }

  const updateSelectedLogos = (selectedLogo) => {
    var newSelectedLogos = JSON.parse(JSON.stringify(selectedLogos));
    for (var i = 0; i < newSelectedLogos.length; i++) {
      console.log(newSelectedLogos[i], selectedLogo);
      if (newSelectedLogos[i].subsiteDecorationId === selectedLogo.subsiteDecorationId) {
        console.log("FOUND LOGO TO MOVE");
        newSelectedLogos[i].x = selectedLogo.x;
        newSelectedLogos[i].y = selectedLogo.y;
        newSelectedLogos[i].width = selectedLogo.width;
        newSelectedLogos[i].height = selectedLogo.height;
        newSelectedLogos[i].rotate = selectedLogo.rotate;
        break;
      }
    }
    setSelectedLogos(newSelectedLogos);

    // update logosByPosition
    var newLogosByPosition = JSON.parse(JSON.stringify(logosByPosition));
    for (var i = 0; i < newLogosByPosition.length; i++) {
      for (var j = 0; j < newLogosByPosition[i].length; j++) {
        if (newLogosByPosition[i][j].subsiteDecorationId === selectedLogo.subsiteDecorationId) {
          newLogosByPosition[i][j].x = selectedLogo.x;
          newLogosByPosition[i][j].y = selectedLogo.y;
          newLogosByPosition[i][j].width = selectedLogo.width;
          newLogosByPosition[i][j].height = selectedLogo.height;
          newLogosByPosition[i][j].rotate = selectedLogo.rotate;
          break;
        }
      }
    }
    setLogosByPosition(newLogosByPosition);
  }

  const saveLogoPosition = async (e) => {
    console.log("SAVE LOGO POSITION", selectedDecoration);
    var logoPosition = {
      productId: currentItem.sizes[0].productId,
      x: selectedDecoration.x,
      y: selectedDecoration.y,
      width: selectedDecoration.width,
      height: selectedDecoration.height,
      rotate: selectedDecoration.rotate,
      logo: selectedDecoration.subsiteDecorationId,
      imageUrl: currentImage.imageUrl,
      updateMode: updateMode
    }

    setLogoPosiitonSpinner(true);
    await LogoService.updateLogoPositionForStyle(logoPosition);
    setLogoPosiitonSpinner(false);

  }
  const addLogo = async (location, logo, updateMode) => {
    console.log("ADD LOGO", location, logo, updateMode);
    await LogoService.addLogo({ productId: currentItem.sizes[0].productId, logoId: logo.id, locationId: location, updateMode: updateMode, imageUrl: currentImage.imageUrl });
    loadImages(currentItem.sizes[0].productId);
  }

  const deleteLogo = async (logo) => {
    console.log("DELETE LOGO", logo);
    await LogoService.deleteLogo(logo.subsiteDecorationId);
    loadImages(currentItem.productId);
  }

  const closeLogoModalShow = () => {
    setAddLogoModalShow(false);
  }
  const selectedLogo = (e) => {
    console.log("Selected Logo", e.target.value);
    setSelectedDecoration(e.target.value);
  }

  const handleDescriptionModalSave = async () => {
    console.log("SAVE DESCRIPTION", currentItem);
    var content = await CatalogService.updateDescription(currentItem.productId, editedHtmlDescription);
    setShowDescription(false);
    setDescriptionChanged(!descriptionChanged);
  }
  const updateModeChanged = (mode) => {
    console.log("UPDATE MODE", mode);
    setUpdateMode(mode);
  }

  const setAsFeatured = async () => {
    console.log("SET AS FEATURED", currentItem);
    var status = await AdminService.addFeatured(currentItem.productId);
    if (status.error) {
      setAddFeaturedMessage(status.message);
    } else {
      setAddFeaturedMessage("Set as Featured");
    }
  }

  const galleryImageClicked = async (image) => {
    setCurrentImage(image);
    setImgSrc(image.imageUrl);
    for (var i = 0; i < currentImages.length; i++) {
      if (currentImages[i].imageUrl === image.imageUrl) {
        await updateLogosByPostion(currentImages[i].logos);
        break;
      }
    }
  }

  const addToNewHireKit = async () => {
    console.log("ADD TO NEW HIRE KIT", currentItem, selectedLogos);
    await CatalogService.addNewHireKitItem(currentItem.productId, selectedLogos);
  }

  const cloneProduct = async (subsites) => {
    console.log("CLONE PRODUCT", currentItem, subsites);
    var newProduct = await CatalogService.cloneProduct(currentItem.productId, subsites);
    //navigate("/admin/product/" + newProduct.productId);
  }

  const loadImages = async (productId) => {
    let images = await CatalogService.getImagesForProduct(productId);
    setCurrentImages(images.images);
    if (images && images.images.length > 0) {
      setCurrentImage(images.images[0]);
      await updateLogosByPostion(images.images[0].logos);
    } else {
      setCurrentImage(null);
      await updateLogosByPostion([]);
    }
  }


  const updateCategory = async (id, value) => {
    CategoryService.updateCategoryForProduct(id, value, currentItem.productId);
    console.log("UPDATE CATEGORY", id, value);
    dispatch(getMenu());
  }

  const closeProductCloneModal = () => {
    //ModalShow(false);
  }

  const updateIgniteCategoryForStyle = async (categoryId, checked) => {
    const status = await CategoryService.updateIgniteCategoryForStyle(categoryId, checked, currentStyle.id);
  }

  const updatePrices = async () => {
    console.log("UPDATE PRICES");
    setPriceUpdateSpinner(true);
    await AdminService.updatePrices(currentItem.productId);
    setPriceUpdateSpinner(false);
    dispatch(getAdminCatalogItem(productId));
  }

  const formatPantsSize = (sizeName) => {
    var isFour = /^\d{4}$/.test(sizeName);
    if (isFour) {
      return sizeName.substring(0, 2) + "x" + sizeName.substring(2);
    } else {
      return sizeName;
    }
  }

  let content = "";
  let price = 0;

  if (itemStatus === 'loading') {
    content = <Spinner text="Loading..." />
  } else if (itemStatus === 'succeeded') {
    price = catalogItem[0].sizes[0]?.costSingle2X;
    let sizes = new Array();

    let currItem = currentItem ? currentItem : catalogItem[0];

    for (var i = 0; i < currItem.sizes.length; i++) {
      var inv = inventory.find(item => item.uniqueKey == currItem.sizes[i].uniqueKey);
      if (loginStatus)
        sizes.push(
          <Row>
            <Col>{formatPantsSize(currItem.sizes[i].sizeName)}</Col>
            <Col>{currItem.sizes[i].cost.toLocaleString(undefined, { maximumFractionDigits: 2 })}</Col>
            <Col>{currItem.sizes[i].price2X.toLocaleString(undefined, { maximumFractionDigits: 2 })}</Col>
            <Col>{currItem.sizes[i].costSingle2X.toLocaleString(undefined, { maximumFractionDigits: 2 })}</Col>
            <Col>{inv?.quantity}</Col>
          </Row>
        );
      else
        sizes.push(<div><Button key={i} variant="secondary" data={i} onClick={(event) => { sizeClick(event); }}>{currItem.sizes[i].sizeName}</Button></div>);
    }

    content = (
      <div class="product-details-container">
        <div class="product-img-lg">
          <div className="main-image-container">
            <div style={{ display: "inline-block", position: "relative" }}>
              <img className="bg-image" src={imgSrc ? imgSrc : catalogItem[0].frontModelImage} width={'100%'} onClick={imageClicked}></img>
              {currentImage && currentImage.canHaveLogo && selectedLogos && selectedLogos.map((logo, i) => (
                <img className="logo-image" src={apiUrl + logo.imageUrl} width={logo.width + '%'} style={{ left: logo.x + '%', top: logo.y + '%', transform: 'rotate(' + logo.rotate + 'deg)' }}></img>
              )
              )}

            </div>


            <div className="small-image-container">
              {currentImages && currentImages.map((image, i) => (
                <img src={image.imageUrl} height={75} onClick={() => galleryImageClicked(image)}></img>
              ))}
            </div>
            <div>
              <Container>
                <Row>
                  <Col>
                    Logo Position and Size:
                  </Col>
                </Row>
                <Row>
                  <Col>
                    Update Mode:<br />
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<input type="radio" id="color" name="updateMode" onClick={() => updateModeChanged('color')} />Update this color<br />
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<input type="radio" id="all" name="updateMode" onClick={() => updateModeChanged('all')} />Update All Colors
                  </Col>
                </Row>
                <Row>
                  <Col>
                    Size:
                    <Button onClick={() => increaseLogoSize()}><PlusLg size={20} /></Button>
                    <Button onClick={() => decreaseLogoSize()}><DashLg size={20} /></Button>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    Rotation:
                    <Button onClick={() => rotateClockwise()}><ArrowClockwise size={20} /></Button>
                    <Button onClick={() => rotateCClockwise()}><ArrowCounterclockwise size={20} /></Button>

                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Button onClick={() => saveLogoPosition()} disabled={logoPosiitonSpinner}>{logoPosiitonSpinner && <Spinner size="sm" animation="border" role="status" />} Save Logo Position</Button>
                  </Col>
                </Row>

              </Container>
            </div>

          </div>


        </div>
        <div class="product-content">
          <div><hr /></div>
          <div style={{ margin: 0, padding: 0 }}><span style={{ fontWeight: "bold", color: "#999999" }}>TITLE:</span></div>
          <div class="title">{catalogItem[0].title}</div>
          <div><hr /></div>
          <div style={{ margin: 0, padding: 0 }}><span style={{ fontWeight: "bold", color: "#999999" }}>DESCRIPTION: <LogoButton style={{ color: "blue" }} size="25" Icon={Pencil} tooltip="Edit Description" onClick={() => setShowDescription(true)} /></span></div>
          <div class="description" dangerouslySetInnerHTML={{ __html: catalogItem[0].htmlDescription ? catalogItem[0].htmlDescription : catalogItem[0].description }} />
          <div><hr /></div>
          {loginStatus ? (
            <>
              <div style={{ margin: 0, padding: 0 }}><span style={{ fontWeight: "bold", color: "#999999" }}>PRICE:</span> <LogoButton style={{ color: "blue" }} size="25" Icon={ArrowClockwise} tooltip="Update Price from Sanmar" onClick={updatePrices} disabled={priceUpdateSpinner} />
                {priceUpdateSpinner && <Spinner size="sm" animation="border" />}</div>

              <div class="price">${(currentItem?.sizes[0]?.costSingle2X + currentLogoPrice).toLocaleString(undefined, { maximumFractionDigits: 2 })} ({currentItem?.sizes[0]?.costSingle2X} + {currentLogoPrice}) </div>
            </>
          ) : null

          }
          <div><hr /></div>

          <CategoryList style={currentStyle} editEnabled={true} updateIgniteCategoryForStyle={updateIgniteCategoryForStyle} />
          <div><hr /></div>

          <div className="color-title">
            <span style={{ fontWeight: "bold", color: "#999999" }}>DECORATIONS:</span> <LogoButton style={{ color: "green" }} size="25" Icon={PlusCircle} tooltip="Add Decoration" onClick={() => setAddLogoModalShow(true)} />
          </div>
          <div style={{ padding: 5 }}>
            {logosByPosition && logosByPosition.map(logos => {
              return logos.map(logo => {
                console.log("LOGO", logo.subsiteDecorationId);
                console.log("Selected Logo", selectedDecoration);
                if (logo.oppoColor) {
                  return (
                    <div>
                      <div style={{ display: "flex", padding: 5, flexDirection: "row", flexWrap: "wrap", borderStyle: "solid", borderWidth: 1, borderColor: logo.subsiteDecorationId === selectedDecoration.subsiteDecorationId ? "#0000FF" : "#CCCCCC" }}>
                        <div style={{ flex: 1 }}><img src={apiUrl + logo.imageUrl} height={50} style={{ padding: 5, backgroundColor: "#CCCCCC" }} onClick={() => decoClicked(logo)} /></div>
                        <div style={{ flex: 1, marginLeft: 5, fontSize: 12 }}>{logo.decorationName}<br />{logo.locName}<br />{logo.type}</div>
                        <Button onClick={() => toggleLightLogo(logo)}><Shuffle /></Button>
                        <LogoButton style={{ color: "red" }} size="25" Icon={XCircle} tooltip="Remove Decoration" onClick={() => deleteLogo(logo)} />
                      </div>
                    </div>
                  );
                } else {
                  return (
                    <div style={{ display: "flex", padding: 5, flexDirection: "row", flexWrap: "wrap", borderStyle: "solid", borderWidth: 1, borderColor: logo.subsiteDecorationId === selectedDecoration.subsiteDecorationId ? "#0000FF" : "#CCCCCC" }}>
                      <div style={{ flex: 1 }}><img src={apiUrl + logo.imageUrl} height={50} style={{ padding: 5, backgroundColor: "#CCCCCC" }} onClick={() => decoClicked(logo)} /></div>
                      <div style={{ flex: 1, marginLeft: 5, fontSize: 12 }}>{logo.decorationName}<br />{logo.locName}<br />{logo.type}</div>
                      <LogoButton style={{ color: "red" }} size="25" Icon={XCircle} tooltip="Remove Decoration" onClick={() => deleteLogo(logo)} />
                    </div>
                  );
                }
              })
            }
            )}
          </div>
          <div><hr /></div>
          <span style={{ fontWeight: "bold", color: "#999999" }}>ACTIONS:</span>
          <ul>
            <li>Set As Featured <LogoButton style={{ color: "blue" }} size="25" Icon={Asterisk} tooltip="Set as Featured" onClick={setAsFeatured} />
              {addFeaturedMessage && (
                <><br /><div style={{ color: "#009900" }}><Check size="20"></Check>Set as Featured Item</div></>
              )}
            </li>
            <li>Add to New Hire Kit <LogoButton style={{ color: "green" }} size="25" Icon={PlusCircle} tooltip="Add to New Hire Kit" onClick={addToNewHireKit} /></li>
          </ul>
          <div><hr /></div>
            <span style={{ fontWeight: "bold", color: "#999999" }}>LIMIT TO ROLE:</span><br/>
            <ul style={{listStyleType: "none"}}> 
              <li><input type="checkbox" value="manager" onChange={(e) => CatalogService.limitProductToRole(currentItem.productId, "manager", e.target.checked)} /> Manager</li>
              <li><input type="checkbox" value="supervisor" onChange={(e) => CatalogService.limitProductToRole(currentItem.productId, "supervisor", e.target.checked)} /> Supervisor</li>
            </ul>
          <div><hr /></div>
          <div class="color-title">
            <span style={{ fontWeight: "bold", color: "#999999" }}>Color:</span> {currentColor ? currentColor : catalogItem[0].colorName}
          </div>
          <div class="color-title">
            Selected Colors:
          </div>
          <div class="colors" onDrop={addColorDrop} onDragOver={allowDrop}>
            {selectedColors && selectedColors.map(item => (
              <div class="color-swatch" style={{ position: "relative" }}>
                <img src={`https://cdnm.sanmar.com/swatch/gifs/${item.squareImageName}`} height={50}
                  onClick={(event) => colorImageClick(item)}
                  onDragEnd={() => drop(item)}
                  onDragStart={() => dragStarted(item)}
                  key={item.colorName}
                  draggable
                />
              </div>
            ))}
          </div>
          <div class="color-title">
            Available Colors:
          </div>
          <div class="colors" onDrop={removeColorDrop} onDragOver={allowDrop}>
            {availableColors && availableColors.map(item => (
              <div class="color-swatch" style={{ position: "relative" }}>
                <img src={`https://cdnm.sanmar.com/swatch/gifs/${item.squareImageName}`} height={50}
                  onClick={(event) => colorImageClick(item)}
                  onDragEnd={() => drop(item)}
                  onDragStart={() => dragStarted(item)}
                  key={item.colorName}
                  draggable
                />
              </div>
            )
            )}
          </div>
          <div><hr /></div>
          <div class="color-title">
            Sizes:
          </div>
          <div class="sizes">
            <Container>
              <Row>
                <Col>Size</Col>
                <Col>Cost</Col>
                <Col>Cost 2XL</Col>
                <Col>Retail</Col>
                <Col>Inv</Col>
              </Row>
              {sizes}
            </Container>
          </div>
          <div><hr /></div>
        </div>
      </div>
    );

  } else if (itemStatus === 'failed') {
    content = <div>error</div>
  }

  return (
    <div className="container">
      <ProductMenu url="/admin/catalog/" menuBgColor={currentSubsite.subsite_content?.menuBgColor} menuTextHoverColor={currentSubsite.subsite_content?.menuTextHoverColor} menuTextColor={currentSubsite.subsite_content?.menuTextColor} />

      {content}
      <Button onClick={removeProduct}>Remove From Catalog</Button>
      {isLoggedIn && isSuperAdmin && (
        <Button onClick={() => setCloneProductModalShow(true)}>Clone Product to Other Sites</Button>
      )}
      <br />
      <br />
      <br />
      <Modal show={show} onHide={handleSizeModalClose}>
        <Modal.Header closeButton>
          <Modal.Title>Available Sizes for<br /> {currentDragColor}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {addSizes}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleSizeModalClose}>
            Cancel
          </Button>
          <Button variant="primary" onClick={handleAddSizesClick}>
            Add Sizes
          </Button>
        </Modal.Footer>
      </Modal>
      <Modal show={showDescription} onHide={handleDescriptionModalClose}>
        <Modal.Header closeButton>
          <Modal.Title>Description</Modal.Title>
        </Modal.Header>
        <Modal.Body>

          <ReactQuill theme="snow" value={editedHtmlDescription} onChange={setEditedHtmlDescription} />

        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleDescriptionModalClose}>
            Cancel
          </Button>
          <Button variant="primary" onClick={handleDescriptionModalSave}>
            Update Description
          </Button>
        </Modal.Footer>
      </Modal>


      <AddLogoModal show={addLogoModalShow} closeModal={closeLogoModalShow} addLogo={addLogo} />
      {cloneProductModalShow && (
        <CloneProductModal show={cloneProductModalShow} closeModal={closeProductCloneModal} cloneProduct={cloneProduct} />
      )}
    </div>
  );
};
export default ProductDetails;
